import { Model as VuexOrmModel } from '@vuex-orm/core';
import { paramCase } from 'change-case';
import find from 'lodash/find.js';
import map from 'lodash/map.js';

import { displaySeconds, initialState } from '@/Helpers.js';
import moment from '@/plugins/vue-moment.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class Model extends VuexOrmModel {
    static _cache = [];

    static fields() {
        return {
            created_by: this.attr(null),
            updated_by: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }

    $exists() {
        return !!this.id && this.id !== this.$id;
    }

    /**
     *
     * @param field
     * @param tz
     * @returns {Moment}
     */
    timestamp(field, tz = null) {
        const timezone = tz || initialState('InstitutionSettings.timezone');

        return moment.utc(this[field]).tz(timezone);
    }

    /**
     *
     * @param field
     * @param tz
     * @returns {Date}
     */
    nativeDate(field, tz = null) {
        return this.timestamp(field, tz).toDate();
    }

    deleteModel(endpoint = null) {
        if (!endpoint) {
            endpoint = paramCase(this.constructor.entity);
        }

        return this.constructor.api().delete(`/api/${endpoint}/${this.id}`, { delete: this.id });
    }

    fromSecondsToDisplay(field) {
        return displaySeconds(this[field]);
    }

    static sortUsingResponse({ response }, models) {
        const idOrder = map(response.data.data, 'id');

        const newOrder = [];

        idOrder.forEach(id => newOrder.push(find(models, { id })));

        return newOrder;
    }

    triggerAutosave(indicator) {
        this.store().dispatch('AutoSave/setSaving', {
            indicator: indicator || this.modelName || 'Model',
            id: this.id,
        });
    }

    finishAutosave(indicator) {
        this.store().dispatch('AutoSave/setSaved', {
            indicator: indicator || this.modelName || 'Model',
            id: this.id,
        });
    }

    static async lazyFind(id, queryCallback) {
        if (!id) {
            return null;
        }

        const identifier = Number.parseInt(id, 10);

        let query = new QueryBuilder(`${paramCase(this.entity)}/${identifier}`);

        if (queryCallback) {
            query = queryCallback(query);
        }

        let model = query.applyToModel(Model.store().$db().model(this.entity)).where('id', id).first();

        if (!model) {
            await super.api().get(query.toUrl());

            model = query.applyToModel(Model.store().$db().model(this.entity)).where('id', id).first();
        }

        return model;
    }
}
